export const SEND_CURRENCY_TIMER_COOLDOWN: number = 86400000;
export const REQUEST_CURRENCY_TIMER_COOLDOWN: number = 86400000;
export const FRIEND_GIFT_TIMER_COOLDOWN: number = 86400000;
export const FRIEND_ALT_GIFT_TIMER_COOLDOWN: number = 86400000;
export const HELPER_FRIENDS_COOLDOWN: number = 86400000;
